import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMessageMacros } from '../../actions';
import { Content } from '../layout';
import { pageLimit as limit } from '../../config/keys';
// import Pagination from "../common/Pagination";
import { fabStyle } from '../common/style';

const MessageMacroList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  // const { count = 0, rows = [] } = useSelector(
  //   (state) => state.messageMacro.messageMacros
  // );

  const { data } = useSelector((state) => state.messageMacro);

  useEffect(() => {
    dispatch(fetchMessageMacros(page, limit));
  }, [dispatch, page]);

  const navigateToMessageMacroDetail = (id) => {
    navigate(`/messages/macros/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderMessageMacros = () =>
    data?.rows?.map((messageMacro) => (
      <TableRow
        key={messageMacro.id}
        onClick={() => navigateToMessageMacroDetail(messageMacro.id)}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>{messageMacro.macroId}</TableCell>
        <TableCell>{messageMacro.subject}</TableCell>
        <TableCell>
          {new Date(messageMacro.createdAt).toLocaleString()}
        </TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            메시지 매크로
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="messgeMacro-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>매크로 ID</TableCell>
                  <TableCell>제목</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderMessageMacros()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={data?.count || 0}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/messages/macros/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default MessageMacroList;
